<template>
    <Page>
        <Container>
            <div class="mx-auto max-w-sm">
                <Help>
                    Manage the bands you train with, including custom names, brands, and colors for your exact setup.
                </Help>
                <BandResourceList :key="$route.fullPath" />
            </div>
        </Container>
    </Page>
</template>

<script>
import {defineComponent} from 'vue'
import BandResourceList from '@/components/Band/ResourceList.vue';
import Help from '@/components/Help.vue';

export default defineComponent({
  name: 'Index',
  components: {
    BandResourceList,
    Help,
  },
});
</script>

<style scoped lang="scss">

</style>
